import { helpers } from '../services/helpers';
import { Link } from 'react-router-dom';
import { FaPlusCircle, FaRegComment } from 'react-icons/fa';
import StarRating from './StarRating';
import Updates from './Updates';
import ProfileHover from './ProfileHover';
import FeedCardFooter from './FeedCardFooter.js';
import EditFeedCardFooter from './EditFeedCardFooter.js';
import ProfileImage from './ProfileImage.js';
import Tooltip from './Tooltip.js';
import React, { useState, useEffect } from 'react';
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import { Lock } from 'lucide-react';
import './ReviewDetail.css';
import './UserList.css';

// TODO: ADD LINKS AND FILTERS FOR DOCTOR AND STATE

function FeedCard({ toast, review, updateReview, onLogin, user, loadReviews }) {

    const toggleTimeline = () => {
        updateReview({ ...review, showUpdates: !review.showUpdates })
    }
    return (
        <div className="review-card">

            {!review.public && (
                <div style={{ display: 'flex', justifyContent: 'space-between', }} className="card-line-header">
                    <div className="review-header" style={{ height: '24px', fontSize: '14px' }}>
                        <span className="tooltip-container" style={{ display: 'flex', alignItems: 'center' }}>
                            <Lock />
                            <div style={{ color: '#2880B9', marginLeft: "0.5rem" }}>
                                Private
                            </div>
                            <span className="tooltip-text">Only you can see this card.</span>
                        </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                    </div>
                </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between' }} className="card-line-header">
                <div className="review-header" style={{ height: '24px', fontSize: '14px' }}>
                    <div style={{ fontWeight: 'bold', color: '#606366' }}>{review.state.code}&nbsp;•&nbsp;</div>
                    <div style={{ color: '#000000' }}>
                        {review.surgeon.name.replace(/,\s*m\.?d\.?$/i, '')}
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {Boolean(review.rating) && (
                        <StarRating rating={review.rating} className="star-rating" />
                    )}
                </div>
            </div>
            <div style={{ padding: '0 0.5rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip content={<ProfileHover profile={review.patient} />}>
                            <ProfileImage profile={review.patient} />
                        </Tooltip>
                        <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '4px' }}>
                            <Tooltip content={<ProfileHover profile={review.patient} />}>
                                <div style={{ fontSize: '14px', fontWeight: 'bold', height: '18px' }}>
                                    {review.patient.username}
                                </div>
                            </Tooltip>
                            <div className="review-date" style={{ fontSize: '12px' }}>
                                {helpers.formatUpdatedAt(review.updatedAt)}
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
                        <div className="post-op-timestamp">{helpers.postopTimestampAt(review.surgeryDate, review.updatedAt)}</div>
                    </div>
                </div>


                <div className="review-details">
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {review.procedures.map((procedure, index) => {
                            return (
                                <div key={index} style={{ fontWeight: '600', fontSize: '14px' }}>
                                    <span className="tooltip-container" style={{ display: 'flex', alignItems: 'center' }}>
                                        <InformationCircleIcon
                                            style={{
                                                width: '1rem',
                                                height: '1rem',
                                                cursor: 'pointer',
                                                color: '#3498DA'
                                            }}
                                            aria-hidden="true"
                                        />
                                        {helpers.procedureDisplay(procedure)}

                                        <span className="tooltip-text">{procedure.description}</span>
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <p className="review-description">{review.description}</p>
                {review && review.updates && review.updates.length > 1 && (
                    !review.showUpdates ? (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                            <button className="show-replies-button review-detail-toggle" style={{ magin: 'auto', padding: '0.5rem' }} onClick={toggleTimeline}>
                                <FaPlusCircle className="reply-icon feed-reply" />
                                Show Full Timeline
                            </button>
                        </div>
                    ) : (
                        <Updates
                            review={review}
                            updates={review.updates}
                            loadReviews={loadReviews}
                            toast={toast}
                            isEditable={review.patient.id === user?.id}
                        />
                    )
                )}
            </div>
            <FeedCardFooter
                review={review}
                updateReview={updateReview}
                onLogin={onLogin}
                user={user}
            />
            {
                review.patient.id === user?.id && (
                    <EditFeedCardFooter
                        review={review}
                        toast={toast}
                        loadReviews={loadReviews}
                    />
                )
            }
        </div >
    )
}

export default FeedCard;